import {
  ColumnOption,
  GenericSchemaSection,
  JsonSchema,
} from "../../../../types";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { getSchemaSections } from "../schemaHelpers";
import { autoFitColumns, styleHeader } from "../export/worksheetBuilder";
import { getChildCollections } from "../export/schemaInspector";

// for setups having single correlation child collection & requires merged sheet

export const downloadMergedSheetUploadTemplate = async ({
  schema,
  setupName,
}: {
  schema: JsonSchema;
  setupName: string;
}): Promise<void> => {
  const headers: string[] = [];
  const dropdownFields: ColumnOption[] = [];

  const sections = getSchemaSections(schema);
  const childCollections = getChildCollections(schema);
  const childCollection = childCollections[0];

  if (!childCollection) {
    return;
  }

  const parentFields = sections
    .flatMap((section: GenericSchemaSection) => section.sectionValue)
    .filter(
      (fieldKey: string) =>
        !childCollections.some((cc) => cc.field === fieldKey),
    );

  parentFields.forEach((fieldKey: string) => {
    const property = schema.properties?.[fieldKey];

    if (!property?.title) {
      return;
    }

    headers.push(property.title);

    if (Array.isArray(property.enum) && property.enum.length > 0) {
      dropdownFields.push({
        colIndex: headers.length,
        options: property.enum,
      });
    }
  });

  Object.entries(childCollection.properties).forEach(([, property]) => {
    if (property?.isHidden || !property?.title) {
      return;
    }

    headers.push(property.title);

    if (Array.isArray(property.enum) && property.enum.length > 0) {
      dropdownFields.push({
        colIndex: headers.length,
        options: property.enum,
      });
    }
  });

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(setupName);

  worksheet.addRow(headers);

  styleHeader(worksheet);
  autoFitColumns(worksheet);

  const MAX_ROWS = 1000;

  dropdownFields.forEach(({ colIndex, options }) => {
    for (let row = 2; row <= MAX_ROWS; row++) {
      worksheet.getCell(row, colIndex).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${options.join(",")}"`],
        showErrorMessage: true,
      };
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();

  saveAs(new Blob([buffer]), `${setupName}-RecordUploadTemplate.xlsx`);
};
